module.exports = ".links-title {\n  text-align: center; }\n\n.links-desctiption {\n  text-align: center;\n  color: #09c3c6;\n  white-space: pre-wrap; }\n\n.sms-inactive {\n  color: #f18600;\n  font-weight: bold; }\n\n.row.equal {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/links-2/links.component.scss
// module id = ./src/app/modules/sessions/links-2/links.component.scss
// module chunks = main